import { render, staticRenderFns } from "./CarouselGrid.vue?vue&type=template&id=d0c48a50"
import script from "./CarouselGrid.vue?vue&type=script&lang=js"
export * from "./CarouselGrid.vue?vue&type=script&lang=js"
import style0 from "./CarouselGrid.vue?vue&type=style&index=0&id=d0c48a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports